import formatLongDatetime from './datetime'
import formatTime from './time'
import formatMinutes from './minutes'

export default {
  install (Vue) {
    Vue.filter('formatLongDatetime', function (value) {
      return formatLongDatetime(value)
    })
    Vue.filter('formatTime', function (value) {
      return formatTime(value)
    })
    Vue.filter('formatMinutes', function (value) {
      return formatMinutes(value)
    })
  }
}
